import { handleReturn, MutationFunction, PaginatedResponse, QueryFunction } from '@query/root.ts'
import { network } from '@utils'

interface HolviAuthorizeUrlProps {
  slug: string
  redirectUrl: string
}

export interface IHolviAuthorizeUrlResponse {
  url: string
}

export const fetchHolviAuthorizeUrl: QueryFunction<
  HolviAuthorizeUrlProps,
  IHolviAuthorizeUrlResponse
> = async ({ slug, redirectUrl }) => {
  const url = `/v1/integrations/business/${slug}/holvi/authorize/`
  const { data, status } = await network.httpClient.request({
    url,
    method: 'GET',
    params: { redirect_url: redirectUrl },
    validateStatus: () => true
  })
  return handleReturn({ data, status })
}

interface HolviAccountListProps {
  slug: string
}

export const deleteHolviIntegration: MutationFunction<HolviAccountListProps, void> = async ({
  slug
}) => {
  const url = `/v1/integrations/business/${slug}/holvi/delete/`
  await network.httpClient.request({
    url,
    method: 'DELETE'
  })
}

export interface IHolviAccount {
  id: number
  account: number
  uuid: string
  name: string
  iban: string
  type: string
  pool_handle: string

  account_owner: number
  account_admins: number[]

  enabled: boolean
  last_sync_at: string
  begin_sync_from: string
  last_payment_instruction_at?: string
}

export const fetchHolviAccounts: QueryFunction<
  HolviAccountListProps,
  PaginatedResponse<IHolviAccount>
> = async ({ slug }) => {
  const url = `/v1/integrations/business/${slug}/holvi/accounts/`
  const { data, status } = await network.httpClient.request({
    url,
    method: 'GET',
    validateStatus: () => true
  })
  return handleReturn({ data, status })
}

interface HolviAccountInstanceProps {
  slug: string
  accountId: number
}

export const updateHolviAccount: MutationFunction<
  HolviAccountInstanceProps,
  IHolviAccount
> = async ({ slug, accountId }, requestData) => {
  const url = `/v1/integrations/business/${slug}/holvi/accounts/${accountId}/`
  const { data, status } = await network.httpClient.request({
    url,
    method: 'PATCH',
    data: requestData,
    validateStatus: () => true
  })
  return handleReturn({ data, status })
}
